// iPhone, iPod, iPad, and iPadOS (which reports itself as a Mac with a touch screen).
export function isIosDevice(nav) {
  const agent = nav || (typeof navigator !== 'undefined' ? navigator : null);
  if (!agent || agent.MSStream) return false;

  const ua = agent.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;

  const platform = agent.platform || '';
  const touches = agent.maxTouchPoints || 0;
  return platform === 'MacIntel' && touches > 1;
}
